import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';

import {normalize, isApiResponseOk, normalizedDelete} from '../../util/utils';

const deleteTagFromStore = (tagId, state, collections = ['tags']) => {
	let clonedState = _.cloneDeep(state);
	collections.forEach((collection) => {
		const deleteIndex = clonedState?.[collection]?.allIds?.findIndex((x) => x === tagId);
		if (deleteIndex > -1) {
			delete clonedState[collection].byId[tagId];
			clonedState[collection].allIds.splice(deleteIndex, 1);
		}
	});
	return clonedState;
};

export function engagementTagsReducer(state = initialstate.engagementTags, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_TAGS: {
			if (!isApiResponseOk(action)) return state;

			const rawData = Array.isArray(action.response?.data) ? action.response.data : [];
			const targetCollection = action.isManageEntities ? 'manageTags' : 'tags';
			const normalizedCollection = rawData.length > 0 ? normalize(rawData, 'engagementTagId', state[targetCollection], undefined, true) : {...normalize()};
			return {
				...state,
				[targetCollection]: {
					...normalizedCollection,
					page: action.response?.page ?? 1,
					pages: action.response?.pages ?? 1,
					totalEntityCount: action.response?.totalEntityCount ?? rawData.length
				}
			};
		}

		case types.GET_ENGAGEMENT_TAG_BY_ID: {
			// If the tag is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response.status === HttpStatusCodes.NotFound) return deleteTagFromStore(action.tagId, state, ['tags', 'manageTags']);
			return state;
		}

		case types.UPDATE_ENGAGEMENT_TAG: {
			if (action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteTagFromStore(action.tagId, state, ['tags', 'manageTags']);
			}

			if (action?.error) {
				return state;
			}

			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState = _.cloneDeep(state);
				['tags', 'manageTags'].forEach((collection) => {
					const editIndex = newState?.[collection]?.allIds?.findIndex((x) => x === action.response.tagId);
					if (editIndex > -1) {
						newState[collection].byId[action.response.tagId] = {
							...newState[collection].byId[action.response.tagId],
							engagementTagName: action.response.name,
							colorCode: action.response.colorCode,
							id: action.response.tagId
						};
					}
				});
				return newState;
			}
		}

		case types.DELETE_ENGAGEMENT_TAG: {
			if (action.responseObj.status === HttpStatusCodes.NoContent || action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteTagFromStore(action.tagId, state, ['tags', 'manageTags']);
			}
			return state;
		}

		default:
			return state;
	}
}

export function engagementTagReducer(state = initialstate.engagementTag, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_TAG_BY_ID: {
			if (!isApiResponseOk(action)) return state;

			return {
				...state,
				...action.response
			};
		}

		case types.CREATE_ENGAGEMENT_TAG: {
			if (!isApiResponseOk(action)) return state;
			return {
				...state,
				...action.response
			};
		}

		case types.UPDATE_ENGAGEMENT_TAG: {
			if (!isApiResponseOk(action)) return state;
			return {
				...state,
				...action.response
			};
		}

		case types.CLEAR_ENGAGEMENT_TAG: {
			return {};
		}

		default:
			return state;
	}
}
